import { PurchaseOrder } from '../types';
import { toCsvContent } from '@/lib/csv';

/**
 * Purchase Order Utility Functions
 * Pure CSV helpers – no side effects
 * NO database writes, NO business logic, NO toasts
 */

/**
 * Generate finance CSV content
 */
type AdditionalCostForCsv = {
  cost_type: string;
  label: string | null;
  amount: number;
};

export function generateFinanceCSV(
  order: PurchaseOrder,
  additionalCosts?: AdditionalCostForCsv[]
): string {
  if (!order.items) return '';

  const hasAllocations = additionalCosts && additionalCosts.length > 0;
  const headers = [
    'PO_Number', 'SKU', 'Style', 'Colour', 'Size', 'Order_Qty', 'Shipped_Qty', 'Received_Qty', 'Difference',
    'Unit_Cost', 'Override_Price', 'Line_Total',
    ...(hasAllocations ? ['Allocated_Cost', 'Landed_Unit_Cost'] : []),
    'Notes',
  ];
  const rows = order.items.map(item => [
    order.po_number,
    item.sku || '',
    item.category || '',
    item.color || '',
    item.size || '',
    item.ordered_quantity.toString(),
    (item.shipped_quantity ?? 0).toString(),
    (item.received_quantity ?? 0).toString(),
    ((item.received_quantity ?? 0) - item.ordered_quantity).toString(),
    item.unit_cost != null ? item.unit_cost.toFixed(2) : '',
    item.overridden_unit_price != null ? item.overridden_unit_price.toFixed(2) : '',
    item.line_cost_total != null ? item.line_cost_total.toFixed(2) : '',
    ...(hasAllocations ? [
      (item as { allocated_additional_cost?: number }).allocated_additional_cost != null
        ? ((item as { allocated_additional_cost?: number }).allocated_additional_cost ?? 0).toFixed(2) : '0.00',
      (item as { landed_unit_cost?: number }).landed_unit_cost != null
        ? ((item as { landed_unit_cost?: number }).landed_unit_cost ?? 0).toFixed(4) : '',
    ] : []),
    item.notes || ''
  ]);

  const allRows = [headers, ...rows];

  if (additionalCosts && additionalCosts.length > 0) {
    allRows.push([]); // blank separator row
    allRows.push(['PO_Number', 'Cost_Type', 'Label', 'Amount']);
    for (const cost of additionalCosts) {
      allRows.push([
        order.po_number,
        cost.cost_type,
        cost.label || cost.cost_type,
        cost.amount.toFixed(2),
      ]);
    }
  }

  return toCsvContent(allRows);
}
